import axios from 'axios';
export async function leaveImpersonate() {
  const response = await axios.get('/leave_impersonates');
  //show the toast
  setTimeout(() => (window.location.href = response.data.redirection), 500);
}
